module.exports = __webpack_public_path__ + "img/img_join_03.7a965c65.jpg";